<div
	class="owner-preview"
	[class.owner-preview--sm]="size === 'sm'"
	[class.owner-preview--summary-owner-card]="inSummaryOwnerCard"
>
	<div class="owner-preview__avatar" [class.owner-preview__avatar--placeholder]="!hasAvatar">
		<div
			*ngIf="hasAvatar"
			class="picture-image"
			[style.background-image]="'url(' + avatarUrl + ')'"
			role="presentation"
		></div>
		<ng-container *ngIf="!hasAvatar">
			<i [class]="placeholderIcon" aria-hidden="true"></i>
			<span *ngIf="showPlaceholderLabel">{{ 'noImage' | translate }}</span>
		</ng-container>
	</div>
	<div class="owner-preview__body">
		<h4 class="owner-preview__name" [attr.title]="resolvedName">{{ resolvedName }}</h4>
		<div class="owner-preview__meta" *ngIf="meta?.length">
			<div class="info" *ngFor="let item of meta">
				<i [class]="item.icon" aria-hidden="true"></i>
				{{ item.label }}
			</div>
		</div>
		<ng-content></ng-content>
	</div>
</div>
